<app-configuration-page
  title="Simple Import"
  description="Bring instructors, packages, and student accounts into the studio from spreadsheets."
  [breadcrumbs]="[{ label: 'Simple Import' }]">

  <app-simple-import-instructors></app-simple-import-instructors>

  <app-simple-import-packages></app-simple-import-packages>

  <app-simple-import-student-accounts></app-simple-import-student-accounts>

</app-configuration-page>
